module.exports = __webpack_public_path__ + "media/images/brands/brand-gs-64762f719f45fbb7e918c40c3beddefb.jpg";